import { get } from 'object-path-immutable';
import {
  addTheme as addTextTheme,
  overrides as textOverrides,
  extractStyles as extractTextStyles,
} from './text';
import {
  calculateOverridePaths,
  styleToThemeStyle,
  augmentedWrap,
} from './utils';

const PATHS = {
  root: 'style',
  title: 'items.0.items.0',
  subtitle: 'items.1.items.0',
};

export const addTheme = (content, selectedVariant, preserveOverrides) =>
  augmentedWrap(content)
    .set(
      PATHS.title,
      addTextTheme(
        content.items[0].items[0],
        `${selectedVariant}.title`,
        preserveOverrides
      )
    )
    .set(
      PATHS.subtitle,
      addTextTheme(
        content.items[1].items[0],
        `${selectedVariant}.subtitle`,
        preserveOverrides
      )
    )
    .updateStyle(
      PATHS.root,
      { theme: selectedVariant, width: -1 },
      preserveOverrides
    )
    .value();

export const overrides = ({ compiledTheme, content }) =>
  [
    calculateOverridePaths({
      compiledTheme,
      content,
      path: PATHS.root,
      ignore: ['width', 'backgroundImage'],
    }),
    textOverrides({
      compiledTheme,
      content,
      path: PATHS.title,
      pathName: 'title',
    }),
    textOverrides({
      compiledTheme,
      content,
      path: PATHS.subtitle,
      pathName: 'subtitle',
    }),
  ].flat();

export const extractStyles = content => ({
  $style: styleToThemeStyle({
    style: get(content, PATHS.root),
    ignore: ['width', 'backgroundImage'],
  }),
  title: extractTextStyles(get(content, PATHS.title)),
  subtitle: extractTextStyles(get(content, PATHS.subtitle)),
});
